import AsyncStorage from '@react-native-async-storage/async-storage';

function isJSONString(value) {
  try {
    JSON.parse(value);
    return true;
  } catch(e) {
    return false;
  }
}

export const getPendingQRs = async () => {
  let pendingQRsString = await AsyncStorage.getItem('pending_qr_code');
  if( 
    !pendingQRsString 
    || ( pendingQRsString && !isJSONString(pendingQRsString) )
  ) {
    pendingQRsString = '[]';
  }
  return JSON.parse(pendingQRsString);
}

export const addPendingQR = async (qr) => {
  const pendingQRs = await getPendingQRs();
  if(!pendingQRs.includes(qr)) {
    pendingQRs.push(qr);
    await AsyncStorage.setItem('pending_qr_code', JSON.stringify(pendingQRs));

    // save last time adding pending QR to be compared to user's profile_completed_at
    // this addition is to handle user complete their profile outside zoolyfe-club
    await AsyncStorage.setItem( 'last_pending_qr_timestamp', new Date().getTime() );
  }
}

export const deletePendingQR = async (qr) => {
  const pendingQRs = await getPendingQRs();
  const indexOfQR = pendingQRs.indexOf(qr);

  if( indexOfQR >= 0 ) {
    pendingQRs.splice(indexOfQR, 1);
    await AsyncStorage.setItem('pending_qr_code', JSON.stringify(pendingQRs));
  }

  if(pendingQRs.length == 0) {
    await AsyncStorage.removeItem( 'last_pending_qr_timestamp' );
  }
}

export const getLatestPendingQR = async () => {
  const pendingQRs = await getPendingQRs();
  return pendingQRs.pop() ?? null;
}

export const resetPendingQRs = async () => {
  await AsyncStorage.setItem('pending_qr_code', JSON.stringify([]));
  await AsyncStorage.removeItem( 'last_pending_qr_timestamp' );
}